import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useGetStudioDetails } from '~entities/studios/api/get-studio-details';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { getWalletRemovePath } from '../lib/wallet-api-path';
import type {
  RemoveWalletBalanceRequest,
  RemoveWalletBalanceResponse,
} from '../model/types';

export const removeWalletBalanceAPI = async (
  parentId: string,
  data: RemoveWalletBalanceRequest,
  isV2 = false,
) => {
  const response = await baseAPI.post<RemoveWalletBalanceResponse>(
    getWalletRemovePath(parentId, isV2),
    data,
  );
  return response.data;
};

export const useRemoveWalletBalance = (parentId: string) => {
  const queryClient = useQueryClient();
  const { data: studioDetails } = useGetStudioDetails();
  const isV2 = studioDetails?.isV2 === true;

  return useMutation({
    mutationFn: (data: RemoveWalletBalanceRequest) =>
      removeWalletBalanceAPI(parentId, data, isV2),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.WALLET_BALANCE, parentId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT_WALLET_TRANSACTIONS, parentId],
      });
    },
  });
};
